require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./how-should-i-test-my-react-components.json") })
        }
      }, "path---how-should-i-test-my-react-components");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---how-should-i-test-my-react-components!./.cache/json/how-should-i-test-my-react-components.json
// module id = 378
// module chunks = 231608221292675